import { h } from 'preact';
import { render } from '@testing-library/preact';
import { expect } from 'chai';
import { Flex } from '@oracle/oraclejet-preact/UNSAFE_Flex';
import { HiddenAccessible } from '@oracle/oraclejet-preact/UNSAFE_HiddenAccessible';

describe('Test HiddenAccessible component', () => {
  it('render', async function () {
    const content = render(<HiddenAccessible>Text</HiddenAccessible>);
    const sampleText = await content.findByText('Text');
    expect(sampleText).not.null;
  });

  it('render with <Flex> inside', async function () {
    const content = render(<HiddenAccessible><Flex>flex text</Flex></HiddenAccessible>);
    const sampleText = await content.findByText('flex text');
    expect(sampleText).not.null;
  });
});
